export async function will<T, K = any>(tester: Promise<T>): Promise<[K, T]> {
  try {
    const promiseResult = await tester;
    return [null, promiseResult];
  }
  catch (e) {
    return [e, null];
  }
}
